import { BASE_URL } from '../../../../config/environmentConfig';
import * as Sentry from '@sentry/react';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { ISettlementDetailsData } from '../order-interfaces';
import { GET } from '../../store-helper';

export const fetchSettlementsDetailsData = async (id: string, searchParams: any ): Promise<ISettlementDetailsData> => {
	try {
		const params = { ...searchParams };

		if (!params?.pageNumber) {
			params.pageNumber = 1;
		}

		if (!params?.pageSize) {
			params.pageSize = 10;
		}

		return await GET({ pathname: `${BASE_URL.ORDERS}/settlements/${id}/details`, params });

	} catch (e) {
		Sentry.setTag('fetch-settlements-details-id', id);
		sendSentryMessage({ name: `GET Fetch settlements details error`, context: e });
		console.log(e);
	}
};
